import * as R from "ramda";

export default function ApproveChangeConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  pmDataService,
  loaderService,
  ssDialogService,
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmApproveChange = _handleConfirmApproveChange;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }
  /** *********************************************
   * Private Functions
   */

  function _handleConfirmApproveChange() {
    const change = vm.change;
    loaderService.showViewLoader = true;
    let changeToSave = null;
    if (change.changeEntity === 'Batch') {
      changeToSave = _transformBatchChangeForSave(change);
      vm.changesAreRecommended = true;
    } else {
      changeToSave = _transformChangeForSave(change);
    }

    if (vm.changesAreRecommended) {
      pmDataService.acceptSyncedChanges(changeToSave)
        .then(() => {
          let alertMessage;
          if (change.changeEntity === 'Section Title') {
            alertMessage = `Section ${change.documentSectionCode} Title`;
          } else if (change.changeEntity === 'Section Body') {
            alertMessage = `Section "${change.documentSectionCode}" Body`;
          } else if (change.changeEntity === 'EndNote') {
            alertMessage = `Endnote "${change.tag}"`;
          } else if (change.changeEntity === 'Section Sort Order') {
            alertMessage = `Section ${change.documentSectionCode}`;
          } else if (change.changeEntity === 'Section Moved') {
            alertMessage = `Section ${change.documentSectionCode}`;
          } else {
            alertMessage = `Bach ${change.documentSectionCode}`;
          }

          alertMessage += ' has successfully been synced to the recommendation.';
          alerts.success(alertMessage);

          if (vm.updateCallback) {
            vm.updateCallback(change);
          }

          loaderService.showViewLoader = false;
          $rootScope.$broadcast('refreshPMDocuments');
          $rootScope.$broadcast('refreshPmChangeLog');
        });
    } else {
      pmDataService.syncSectionToMaster(change.policyDocumentSectionId)
        .then(() => {
          let alertMessage;
          if (change.changeEntity === 'Section Title') {
            alertMessage = `Section ${change.documentSectionCode} Title`;
          } else if (change.changeEntity === 'Section Body') {
            alertMessage = `Section "${change.documentSectionCode}" Body`;
          } else if (change.changeEntity === 'EndNote') {
            alertMessage = `Endnote "${change.tag}"`;
          } else if (change.changeEntity === 'Section Sort Order') {
            alertMessage = `Section ${change.documentSectionCode}`;
          } else if (change.changeEntity === 'Section Moved') {
            alertMessage = `Section ${change.documentSectionCode}`;
          } else {
            alertMessage = `Bach ${change.documentSectionCode}`;
          }

          alertMessage += ' has successfully been synced to the recommendation.';
          alerts.success(alertMessage);

          if (vm.updateCallback) {
            vm.updateCallback(change);
          }
          loaderService.showViewLoader = false;
          $rootScope.$broadcast('refreshPMDocuments');
          $rootScope.$broadcast('refreshPmChangeLog');
        });
    }

    _closeDialog();
  }
  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pm.confirmApproveChangeDialog);
  }

  function _transformChangeForSave(change) {
    const changeToSave = {
      policyDocumentId: vm.changedIds.policyDocumentId,
    };
    // eslint-disable-next-line max-len
    if (change.changeEntity === 'Section Title' || change.changeEntity === 'Section Body' || change.changeEntity === 'Section Moved' || change.changeEntity === 'Section Sort Order') {
      if (change.changeType === 'Created') {
        changeToSave.addedMasterSectionIds = [change];
      } else if (change.changeType === 'Updated') {
        changeToSave.updatedSectionIds = [change];
      } else {
        changeToSave.deletedSectionIds = [change];
      }
    } else if (change.changeEntity === 'EndNote') {
      if (change.changeType === 'Created') {
        changeToSave.createdMasterEndNoteIds = [change];
      } else if (change.changeType === 'Updated') {
        changeToSave.updatedEndNoteIds = [change];
      }
    }

    return changeToSave;
  }

  function _transformBatchChangeForSave(change) {
    const changeToSave = {
      policyDocumentId: vm.changedIds.policyDocumentId,
    };
    changeToSave.addedMasterSectionIds = [];
    changeToSave.updatedSectionIds = [];
    changeToSave.deletedSectionIds = [];
    // eslint-disable-next-line max-len
    if (change.items && change.items.length > 0) {
      R.forEach(
        (item) => {
          if (item.changeType === 'Created') {
            changeToSave.addedMasterSectionIds.push(item);
          } else if (item.changeType === 'Updated') {
            changeToSave.updatedSectionIds.push(item);
          } else {
            changeToSave.deletedSectionIds.push(item);
          }
        },
        change.items
      );
    }
    return changeToSave;
  }
}

ApproveChangeConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'pmDataService',
  'loaderService',
  'ssDialogService',
];
